export const generateAIButtonTips = ({
  orgName,
  title,
  fieldOfStudy,
  sectionKey,
  isGenerateRangeCrossed,
}) => {
  if (isGenerateRangeCrossed) {
    return 'You have reached the limit of generating content for this section. Please delete some content to generate more.';
  }

  const keyToText = {
    orgName:
      sectionKey === 'education' ? 'Institution name' : 'Organization name',
    title: sectionKey === 'education' ? 'Degree' : 'Title',
    fieldOfStudy: 'Field of study',
  };
  const values = [
    { key: 'orgName', value: orgName },
    { key: 'title', value: title },
    ...(sectionKey === 'education'
      ? [{ key: 'fieldOfStudy', value: fieldOfStudy }]
      : []),
  ].filter((item) => !item?.value);

  if (values.length === 0) {
    return '';
  }

  if (values.length === 1) {
    return `${keyToText[values[0]?.key]} is required to generate content`;
  }

  if (values.length === 2) {
    return `${keyToText[values[0]?.key]} and ${keyToText[values[1]?.key]} are required to generate content`;
  }

  return `${keyToText[values[0]?.key]}, ${keyToText[values[1]?.key]} and ${keyToText[values[2]?.key]} are required to generate content`;
};
